import { render, staticRenderFns } from "./examPointsHaibao.vue?vue&type=template&id=2c49ff04&scoped=true&"
import script from "./examPointsHaibao.vue?vue&type=script&lang=js&"
export * from "./examPointsHaibao.vue?vue&type=script&lang=js&"
import style0 from "./examPointsHaibao.vue?vue&type=style&index=0&id=2c49ff04&prod&scoped=true&lang=scss&"
import style1 from "./examPointsHaibao.vue?vue&type=style&index=1&id=2c49ff04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c49ff04",
  null
  
)

export default component.exports